import React, { useState,useEffect,useCallback } from 'react';
import { Link } from "react-router-dom";
import { GetAllMenus,GetAssignedMenu,saveMenuForTheCslab,CheckAncestorsExist } from "../services/ide-apis";
import ClassRoomMasterLoader from './common/classroom-master-loader';
import CompanyLoader from './common/company-loader';
import { global_var } from '../services/cs-lab-config';
import { message, Divider, Row, Col, Radio, Button, Input, List, Switch } from "antd";
import { LeftOutlined } from "@ant-design/icons";


const ManageCsLabMenu = () => {

  const [availableMenus, setAvailableMenus] = useState([]);
  const [assignedMenus, setAssignedMenus] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedClass, setSelectedClass] = useState(null);
  const [isSaveButtonDisabled, setSaveButtonDisabled] = useState(true);
  const [selectedCompany, setSelectedCompany] = useState(global_var.company_id)
  const [showCompanyLoader, setShowCompanyLoader] = useState(false);
  const [showRadioButton, setShowRadioButton] = useState(false);
 
  
  useEffect(() => {
    loadAllMenus();
  }, []);

  function loadAllMenus(){
    GetAllMenus()
    .then((response) => {
        const data = response.data;

        if (data.statusCode === 200) {
        const menus = data.menus;
        setAvailableMenus(menus || []);
        } else {
        message.error(data.message);
        }
    })
    .catch((error) => {
        console.error('Error fetching menus:', error);
        message.error('Failed to fetch menus. Please try again.');
    });
}

const loadAncestors =() =>{
  const companyId = global_var.company_id
  CheckAncestorsExist(companyId).then((response) =>{
    response= response.data;
    if (response.statusCode ===200){
      setShowRadioButton(response.companyCount > 0);
    } else {
    message.error(response.message);
    }
    })
  }
  useEffect(() => {
    loadAncestors();
  }, []);
const fetchAssignedMenu = useCallback(() => {
    if (selectedCompany && selectedClass) {
      GetAssignedMenu(selectedCompany, selectedClass)
        .then((response) => {
          const data = response.data;
  
          if (data.statusCode === 200) {
            if (Array.isArray(data.menuObject.menuStructure)) {
              const assignedMenus = data.menuObject.menuStructure;
              setAssignedMenus(assignedMenus);
  
              if (assignedMenus.length > 0) {
              
                // setAvailableMenus(prevAvailableMenus =>
                //   prevAvailableMenus.filter(menu => !assignedMenus.some(assignedMenu => assignedMenu._id === menu._id))
                // );
              } else {
                    loadAllMenus();
                    message.info('No assigned menus found. Loading all menus.');
              }
            } else if (typeof data.menuObject === 'object' && Object.keys(data.menuObject).length === 0) {
                setAssignedMenus([]);
                loadAllMenus();
                message.info('No assigned menus found. Loading all menus.');
            }
          } else {
                message.error(data.message);
          }
        })
        .catch((error) => {
            console.error('Error fetching assigned menus:', error);
            message.error('Failed to fetch assigned menus. Please try again.');
        });
    }
  }, [selectedCompany, selectedClass]);
  
  

  const fetchAssignedMenuMemoized = useCallback(() => {
    fetchAssignedMenu();
  }, [fetchAssignedMenu]);

  useEffect(() => {
    fetchAssignedMenuMemoized();
  }, [selectedClass, selectedCompany, fetchAssignedMenuMemoized]);

  const filteredMenus = availableMenus.filter(menu =>
    menu.MenuName.toLowerCase().includes(searchTerm.toLowerCase())
  );  

  const handleClassChange = (classId) => {
    setSelectedClass(classId);
  };
  
  const companyChanged = (companyId) => {
    setSelectedCompany(companyId);
  };

  const handleRadioChange = (e) => {
    setShowCompanyLoader(e.target.value === 'select');
    setSelectedCompany(global_var.company_id)
    setSelectedClass(null);
  };
  
  useEffect(() => {
    updateSaveButtonState(selectedClass);
  }, [selectedClass]);

  const updateSaveButtonState = (classId) => {
    const isSaveButtonDisabled = !classId;
    setSaveButtonDisabled(isSaveButtonDisabled);
  };
  
  const handleSave = () => {
    if (selectedClass && assignedMenus.length > 0) {
      const requestData = {
        classId: selectedClass,
        assignedMenus: assignedMenus,
      };
    if (selectedCompany) {
      requestData.companyId = selectedCompany;
    }
  
      saveMenuForTheCslab(requestData)
        .then((response) => {
          const data = response.data;
  
          if (data.statusCode === 200) {
            message.success('Assigned menus saved successfully!');
          } else {
            message.error(data.message);
          }
        })
        .catch((error) => {
          console.error('Error saving assigned menus:', error);
          message.error('Failed to save assigned menus. Please try again.');
        });
    } else {
      message.warning('Please select a class and at least one assigned menu before saving.');
    }
  };

  const handleToggle = (menuId, toggleStatus) => {
    const selectedMenu = availableMenus.find(menu => menu._id === menuId);
    if (toggleStatus) {
      setAssignedMenus(prevAssignedMenus => [...prevAssignedMenus, selectedMenu]);
    } else {
      setAssignedMenus(prevAssignedMenus =>
        prevAssignedMenus.filter(menu => menu._id !== menuId)
      );
    }
  };

  return (

    <>
      <Row className="mt-3">
        <Col
          className="col d-flex align-items-center"
          justify="space-evenly"
          align="middle"
        >
          <Link to="/" className="mr-2">
          <span className="mt-2 back-button">
            <LeftOutlined  className=" h4" style={{ color: '#000000' }} />
          </span>
          </Link>
          <span className="m-1 mt-2 h4 poppins-medium">CS Lab Menu</span>
        </Col>
      </Row>

      <Divider className="mt-1" style={{backgroundColor:"#D7BEF7"}}/>
      {showRadioButton && (
        <Row className="mb-2 mx-md-3">
          <Col >
          <Radio.Group onChange={handleRadioChange}>
            <Radio value={'all'}>All Schools</Radio> 
            <Radio value={'select'}>Select a School</Radio>
          </Radio.Group>
          </Col>           
        </Row>
      )}

      <div style={{ overflowX: 'auto' }} className="mobile-card-scrollbar">
        <Row className='mt-4 mx-md-3' style={{ flexFlow: 'row' }}>
          <Col className='d-flex'>
            {showCompanyLoader && (
              <div style={{marginRight:'10px'}}>
                <CompanyLoader onChange={companyChanged} />
              </div>
            )}
            <ClassRoomMasterLoader
              classId={selectedClass}
              onChange={handleClassChange}
              showAllOption={false}
              selectMultiple={false}
              loadAllClassRoom={true}
            />
          </Col>
        </Row>
      </div>

      <Row className='bg-white p-3 rounded-3 m-2 mt-3'>
        <Col xs={18} md={10}>
          <Row className='mx-2 mb-2'>
            <Col>
              <span className='poppins-medium' style={{fontSize:'18px'}}>Available CS Lab Menus</span>
              <span className='poppins-regular text-midgrey d-block'>Activate / Deactivate from below menus</span>
            </Col>
          </Row>
          <Row className='mx-2'>
            <Col xs={24}>
              <Input.Search
                bordered={false}    
                placeholder='Search Menu'
                style={{ width: "100%", border:'1px solid #D7BEF7', borderRadius:'6px',backgroundColor:'#FFFFFF' }}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              
              <List className='mt-2 menu-list'
                dataSource={filteredMenus}
                renderItem={(item) => {
                  const isMenuAssigned = assignedMenus.some(assignedMenu => assignedMenu._id === item._id);
                  return (
                    <List.Item 
                      style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span className='poppins-regular'>{item.MenuName}</span>
                      <Switch 
                        checked={isMenuAssigned ? true : false}                      
                        style={{ backgroundColor: isMenuAssigned ? '#83C545' : '#dfdfdf' }}                      
                        onChange={(checked) => handleToggle(item._id, checked)}
                        />
                    </List.Item>
                  );
                }}
              />
                
            </Col>
          </Row>
        </Col>
        <Divider />
        <Col xs={24} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button type="primary" onClick={handleSave} disabled={isSaveButtonDisabled}
          >
            Save Changes
          </Button>
        </Col>
      </Row>
    </>
);
};


export default ManageCsLabMenu;





  
